import React, { useMemo } from "react";
import { DateTime } from "luxon";

// Styles
import s from "~/components/cards/journal/JournalAppointmentCard.module.scss";
// hooks
import { IJournalTicketData } from "~/types/journal";
import { formatDate } from "~/utils/helpers";

interface Props {
  actions: {
    onDownload?: (id: number) => void;
    onCancel?: (id: number) => void;
  };
  journalAppointment: IJournalTicketData;
}

const JournalAppointmentCard: React.FC<Props> = ({
  actions,
  journalAppointment,
}) => {
  // Common Data For Appointment
  const doctorName = journalAppointment.doctorName;
  const hospitalName = journalAppointment.hospitalName;
  const specialityName = journalAppointment.specialtyName;
  const appointmentAddress = journalAppointment.address;

  // Data Gathering Data
  const date = new Date(journalAppointment.dt);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  // Date Formatting
  const preFormattedDate = DateTime.utc(year, month, day)
    .toISO()
    .substring(0, 10);
  const formattedDate = useMemo(
    () => formatDate(preFormattedDate, "DDD"),
    [preFormattedDate]
  );
  const formattedDateWeek = useMemo(
    () => formatDate(preFormattedDate, "cccc"),
    [preFormattedDate]
  );
  const formattedDateClock = useMemo(
    () => formatDate(journalAppointment.value, "T"),
    [journalAppointment]
  );

  return (
    <div className={s.card}>
      <div className={s.cardAppointmentTime}>
        <p className={s.cardAppointmentClock}>{formattedDateClock}</p>
        <div className={s.cardAppointmentTimeAdditionalInformation}>
          <div className={s.cardAppointmentTimeDate}>
            <p className="">{formattedDate}</p>
          </div>
          <div>
            <p className="">{formattedDateWeek}</p>
          </div>
        </div>
      </div>
      <div className={s.cardAppointmentInformation}>
        <div className={s.cardAppointmentInformationContainer}>
          <div className={s.cardAppointmentInformationPiece}>
            <p className={s.specialityName}>{specialityName}</p>
            <div>
              <p className={s.doctorName}>{doctorName}</p>
            </div>
          </div>
          <div className={s.cardAppointmentInformationPiece}>
            <div>
              <p className={s.hospitalName}>{hospitalName}</p>
            </div>
            <div>
              <p className={s.appointmentAddress}>{appointmentAddress}</p>
            </div>
          </div>
        </div>
        {!!(actions.onDownload || actions.onCancel) && (
          <div
            className={`${s.cardAppointmentInformationDownloadOptions} ${s.cardAppointmentInformationContainer}`}
          >
            {actions.onDownload && (
              <button
                className="button"
                onClick={() =>
                  actions.onDownload &&
                  actions.onDownload(journalAppointment.id)
                }
              >
                Скачать талон
              </button>
            )}
            {actions.onCancel && (
              <button
                className="button button--outlined"
                onClick={() =>
                  actions.onCancel && actions.onCancel(journalAppointment.id)
                }
              >
                Отменить
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default JournalAppointmentCard;
